import { keepPreviousData } from "@tanstack/react-query";

export const FIVE_MINUTES = 1000 * 60 * 5;
export const THIRTY_MINUTES = 1000 * 60 * 30;
export const ONE_HOUR = 1000 * 60 * 60;

export const QUERY_PRESETS = {
    list: {
        staleTime: FIVE_MINUTES,
        gcTime: THIRTY_MINUTES,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: false,
        placeholderData: keepPreviousData,
        retry: 0,
    },
    detail: {
        staleTime: 0,
        gcTime: FIVE_MINUTES,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        retry: 0,
    },
    default: {
        staleTime: 0,
        gcTime: FIVE_MINUTES,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: false,
        placeholderData: keepPreviousData,
        retry: 0,
    },
    static: {
        staleTime: ONE_HOUR,
        gcTime: ONE_HOUR,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: false,
        retry: 0,
    },
} as const;

export type QueryPreset = keyof typeof QUERY_PRESETS;
